import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Landmark } from "lucide-react";

export function PaBillingCard() {
  const { user, refresh } = useAuth();
  const [ipa, setIpa] = useState("");
  const [split, setSplit] = useState(false);
  useEffect(() => { setIpa(user?.ipaCode || ""); setSplit(!!user?.splitPayment); }, [user]);

  const save = async () => {
    try { await api.patch("/me", { ipaCode: ipa, splitPayment: split }); toast.success("Dati di fatturazione PA salvati"); refresh(); }
    catch (err) { toast.error(typeof err?.response?.data?.detail === "string" ? err.response.data.detail : "Errore"); }
  };

  return (
    <div className="mt-8 card-premium p-6 space-y-4" data-testid="pa-billing-card">
      <div className="flex items-center gap-2"><Landmark className="w-5 h-5 text-gold"/><h3 className="font-display text-xl font-bold">Fatturazione elettronica PA</h3></div>
      <div className="grid md:grid-cols-2 gap-4 items-end">
        <label className="block">
          <span className="overline text-slate-500 mb-2 block">Codice Univoco Ufficio (IPA){user.role === "public_entity" && <span className="text-gold">*</span>}</span>
          <input data-testid="pa-billing-ipa" value={ipa} maxLength={6} onChange={(e) => setIpa(e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ""))} className="w-full border border-slate-300 rounded-xl px-4 py-2.5 text-sm font-mono tracking-wider"/>
        </label>
        <label className="flex items-center gap-2 text-sm cursor-pointer pb-2">
          <input type="checkbox" data-testid="pa-billing-split" checked={split} onChange={(e) => setSplit(e.target.checked)} className="accent-[#D5A34C]"/>
          Soggetto a Split Payment (scissione dei pagamenti)
        </label>
      </div>
      <button type="button" data-testid="pa-billing-save" onClick={save} className="btn-pill-gold text-sm">Salva</button>
    </div>
  );
}
